<template>
  <div :class="$store.state.mobile ? '' : 'px-4'">
    <div v-if="$store.state.mobile">
      <div v-if="loading">
        <v-skeleton-loader
          class="fill-height"
          type="image"
          tile
          height="414"
        />
        <div class="pa-4">
          <v-skeleton-loader
            type="paragraph"
            tile
          />
        </div>
        <div class="sepration" />
        <v-skeleton-loader
          type="article"
          tile
        />
      </div>
      <div v-else>
        <v-carousel
          v-touch="swipeCarousel"
          cycle
          hide-delimiters
          :height="height"
        >
          <v-carousel-item
            v-for="item in detail.images"
            :key="item.picPath"
          >
            <v-img
              :src="item.picPath"
              aspect-ratio="1"
              contain
            />
          </v-carousel-item>
        </v-carousel>
        <v-divider />
        <div class="pa-4 text-h5 line-height-sm">
          {{ $store.getters.languageGetter === '1' ? detail.dnames : detail.dnamesEn }}
          <div class="black--text font-medium my-2">
            <span class="grey--text">
              <template v-if="$store.getters.languageGetter === '1'">
                أقل كمية ممكن طلبها:
              </template>
              <template v-else>
                Moq:
              </template>
            </span>{{ detail.moq }}
          </div>
        </div>
        <div class="sepration" />
        <div class="px-4 py-2 d-flex align-center">
          <div
            v-if="$store.state.usedCountry"
            class="me-auto font-medium d-flex align-center justify-center"
          >
            <span class="text-h3 me-2">{{ $store.getters.countryGetter.currency }}{{ (priceRate(goodsDetail) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
            <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(goodsDetail).toFixed(2) }}</span>/ {{ $store.getters.languageGetter === '1' ? detail.unitName : detail.unitNameEn }}
          </div>
          <v-btn
            icon
            :color="detail.isCollect === '1' ? '#ff4747' : '#f7b4a1'"
            @click="setGoodsFavorite"
          >
            <v-icon>{{ detail.isCollect === '1' ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
          </v-btn>
        </div>
        <div class="sepration" />
        <div class="black--text font-medium pa-4">
          <span class="me-2">
            <template v-if="$store.getters.languageGetter === '1'">ماركة :</template>
            <template v-else>
              Brand:
            </template>
          </span>{{ $store.getters.languageGetter === '1' ? detail.brandName : detail.brandNameEn }}
        </div>
        <div class="black--text font-medium pa-4">
          <span class="me-2">
            <template v-if="$store.getters.languageGetter === '1'">
              أقل كمية ممكن طلبها:
            </template>
            <template v-else>
              Moq:
            </template>
          </span>{{ detail.moq }}
        </div>
        <div class="sepration" />
        <div class="black--text  pa-4">
          <span class="me-2 font-medium">
            <template v-if="$store.getters.languageGetter === '1'">رقم الصنف:</template>
            <template v-else>
              Item No.:
            </template>
          </span>{{ detail.dno }}
        </div>
        <div class="sepration" />
        <div class="pa-4">
          <!-- <div
            v-for="(spec, i) in detail.spec"
            :key="spec.id"
          >
            <div class="black--text font-medium mb-2">
              {{ $store.getters.languageGetter === '1' ? spec.specName : spec.specNameEn }}:
            </div>
            <div class="d-flex flex-wrap">
              <v-card
                v-for="specItem in spec.specItem"
                :key="specItem.id"
                outlined
                class="me-3 mb-3 cursor-pointer py-2 px-6"
                :disabled="specItem.disabled"
                :style="specIds[i] === specItem.id ? 'border-color:red;border-width:2px;padding: 7px 23px !important': ''"
                @click="setSpecDisabled(specItem, i)"
              >
                <div class="black--text">
                  {{ $store.getters.languageGetter === '1' ? specItem.itemName : specItem.itemNameEn }}
                </div>
              </v-card>
            </div>
          </div> -->
          <div
            v-if="detail.containSpec === '1'"
            class="black--text font-medium mb-2"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              تحديد:
            </template>
            <template v-else>
              Specifications:
            </template>
          </div>
          <template v-if="detail.containSpec === '1'">
            <v-divider />
            <div
              v-for="spec in detail.detail"
              :key="spec.id"
            >
              <v-row align="center">
                <v-col cols="auto">
                  <v-img
                    :src="spec.image ? spec.image + '?x-oss-process=image/resize,m_mfit,w_500,h_500' : require('@/assets/imgWaiting.png')"
                    width="60"
                    height="60"
                    aspect-ratio="1"
                    contain
                    @contextmenu="downLoadImg(specItem.image)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </v-col>
                <v-col>
                  <template v-if="$store.getters.languageGetter === '1'">
                    {{ spec.detailName }}
                  </template>
                  <template v-else>
                    {{ spec.detailNameEn }}
                  </template>
                  <div v-if="$store.getters.countryGetter">
                    {{ $store.getters.countryGetter.currency }}{{ (priceRate(spec) * $store.getters.rebateGetter / 100).toFixed(2) }}
                  </div>
                </v-col>
                <v-col>
                  <Stepper
                    :value="+spec.buNumber"
                    square
                    @update:value="spec.buNumber = $event"
                    @update:minus="spec.buNumber = $event"
                    @update:plus="spec.buNumber = $event"
                  />
                </v-col>
              </v-row>
              <v-divider />
            </div>
          </template>
          <div
            v-if="detail.containSpec === '0'"
            class="black--text font-medium mb-2"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              كمية:
            </template>
            <template v-else>
              Quantity:
            </template>
          </div>
          <div
            v-if="detail.containSpec === '0'"
            class="d-flex align-center"
          >
            <stepper
              class="me-4"
              large
              :value="+quantity"
              :disabled="quantity <= +detail.moq"
              @update:value="quantity = $event"
              @update:minus="quantity = $event"
              @update:plus="quantity = $event"
            />
            <div class="grey--text">
              {{ detail.stock }} {{ $store.getters.languageGetter === '1' ? detail.unitName : detail.unitNameEn }}
              <template v-if="$store.getters.languageGetter === '1'">
                متوفرة
              </template>
              <template v-else>
                available
              </template>
            </div>
          </div>
          <v-btn
            large
            color="#ff4747"
            depressed
            dark
            block
            class="my-4"
            :loading="buying"
            @click="buyNow"
          >
            <span class="text-h5">
              <template v-if="$store.getters.languageGetter === '1'">اشتري الآن</template>
              <template v-else>
                Buy Now
              </template>
            </span>
          </v-btn>
          <v-btn
            large
            color="#ff9a00"
            depressed
            dark
            block
            :loading="adding"
            @click="addToCart"
          >
            <v-icon
              left
              size="18px"
              color="#fff"
            >
              mdi-cart-outline
            </v-icon>
            <span class="text-h5">
              <template v-if="$store.getters.languageGetter === '1'">أضف إلى السلة</template>
              <template v-else>
                Add to Cart
              </template>
            </span>
          </v-btn>
        </div>

        <div class="sepration" />
      </div>
    </div>
    <div v-else>
      <div class="ps-4 d-flex align-center py-3">
        <template v-if="$store.getters.languageGetter === '1'">
          فئة المنتج الخاص بك:
        </template>
        <template v-else>
          Your position:
        </template>
        <v-breadcrumbs
          :items="breadcrumbs"
          class="ps-2 py-0"
        />
      </div>
      <v-container
        v-if="loading"
        class="py-0"
      >
        <v-row
          no-gutters
          class="mb-4"
        >
          <v-col cols="auto">
            <v-card
              outlined
              tile
              style="width:500px"
              class="mb-1"
            >
              <v-skeleton-loader
                class="fill-height"
                type="image"
                tile
                height="500"
              />
            </v-card>
          </v-col>
          <v-col class="ps-9">
            <v-skeleton-loader
              class="fill-width fill-height"
              type="heading"
              tile
              height="54"
              width="500"
            />
            <v-skeleton-loader
              class="mt-3 mb-4"
              type="heading"
              tile
            />
            <v-skeleton-loader
              class="my-3"
              type="paragraph"
              tile
            />
            <v-row>
              <v-col
                v-for="i in 6"
                :key="i"
                cols="2"
              >
                <v-skeleton-loader
                  type="image"
                  tile
                  height="80"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="i in 6"
                :key="i"
                cols="4"
              >
                <v-skeleton-loader
                  class="fill-width"
                  type="button"
                  tile
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="sentences"
                  tile
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="d-flex"
              >
                <v-skeleton-loader
                  class="fill-height fill-width me-4"
                  type="button"
                  tile
                  width="200"
                  height="60"
                />
                <v-skeleton-loader
                  class="fill-height fill-width"
                  type="button"
                  tile
                  width="200"
                  height="60"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-skeleton-loader
          type="heading"
          tile
        />
        <v-skeleton-loader
          type="paragraph"
          tile
        />
      </v-container>
      <v-container
        v-else
        class="py-0"
      >
        <v-row
          no-gutters
          class="mb-4"
        >
          <v-col cols="auto">
            <v-card
              outlined
              tile
              style="width:500px"
              class="mb-1"
            >
              <v-img
                :src="specImg ? specImg + '?x-oss-process=image/resize,m_mfit,w_500,h_500' : activeImg + '?x-oss-process=image/resize,m_mfit,w_500,h_500'"
                aspect-ratio="1"
                contain
                class="grey lighten-5 img-hover"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey"
                    />
                  </v-row>
                </template>
              </v-img>
            </v-card>
            <v-row justify="center">
              <v-col
                v-for="(item, i) in detail.images"
                :key="item.picPath"
                cols="2"
              >
                <v-card
                  outlined
                  tile
                  class="cursor-pointer"
                  :style="activeIndex === i ? 'border-color:red;border-width:2px;': ''"
                  @click="activeIndex = i;specImg = ''"
                >
                  <v-img
                    :src="item.picPath + '?x-oss-process=image/resize,m_mfit,w_200,h_200'"
                    aspect-ratio="1"
                    contain
                    class="grey lighten-5"
                    :width="activeIndex === i ? 58 : 60"
                    :height="activeIndex === i ? 58 : 60"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="ps-9">
            <div style="font-size:20px">
              {{ $store.getters.languageGetter === '1' ? detail.dnames : detail.dnamesEn }}
            </div>
            <div class="my-3">
              <span class="black--text font-medium me-2">
                <template v-if="$store.getters.languageGetter === '1'">رقم الصنف:</template>
                <template v-else>
                  Item No.:
                </template>
              </span>
              {{ detail.dno }}
            </div>
            <div
              v-if="$store.state.usedCountry"
              class="d-flex align-center mb-3"
            >
              <span class="text-h3 font-medium me-2">{{ $store.getters.countryGetter.currency }}{{ (priceRate(goodsDetail) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
              <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">${{ priceRate(goodsDetail).toFixed(2) }}</span>/ {{ $store.getters.languageGetter === '1' ? detail.unitName : detail.unitNameEn }}
            </div>
            <div class="my-3">
              <span class="black--text font-medium me-2"><template v-if="$store.getters.languageGetter === '1'">ماركة :</template>
                <template v-else>
                  Brand:
                </template> </span>{{ $store.getters.languageGetter === '1' ? detail.brandName : detail.brandNameEn }}
            </div>
            <div class="my-3">
              <span class="black--text font-medium me-2"><template v-if="$store.getters.languageGetter === '1'">
                                                           أقل كمية ممكن طلبها:
                                                         </template>
                <template v-else>
                  Moq:
                </template> </span>{{ detail.moq }}
            </div>
            <!-- <div
              v-for="(spec, i) in detail.spec"
              :key="spec.id"
            >
              <div class="black--text font-medium mb-2">
                {{ $store.getters.languageGetter === '1' ? spec.specName : spec.specNameEn }}:
              </div>
              <div class="d-flex flex-wrap">
                <v-card
                  v-for="specItem in spec.specItem"
                  :key="specItem.id"
                  outlined
                  class="me-3 mb-3 cursor-pointer py-1 px-4"
                  :disabled="specItem.disabled"
                  :style="specIds[i] === specItem.id ? 'border-color:red;border-width:2px;padding: 3px 15px !important': ''"
                  @click="setSpecDisabled(specItem, i)"
                >
                  <div class="black--text">
                    {{ $store.getters.languageGetter === '1' ? specItem.itemName : specItem.itemNameEn }}
                  </div>
                </v-card>
              </div>
            </div> -->
            <div
              v-if="detail.containSpec === '1'"
              class="black--text font-medium mb-2"
            >
              <template v-if="$store.getters.languageGetter === '1'">
                تحديد:
              </template>
              <template v-else>
                Specifications:
              </template>
            </div>
            <template v-if="detail.containSpec === '1'">
              <v-divider />
              <div
                v-for="spec in detail.detail"
                :key="spec.id"
              >
                <v-row align="center">
                  <v-col cols="auto">
                    <v-img
                      :src="spec.image ? spec.image + '?x-oss-process=image/resize,m_mfit,w_500,h_500' : require('@/assets/imgWaiting.png')"
                      width="60"
                      height="60"
                      aspect-ratio="1"
                      contain
                      @contextmenu="downLoadImg(specItem.image)"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          />
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                  <v-col>
                    <template v-if="$store.getters.languageGetter === '1'">
                      {{ spec.detailName }}
                    </template>
                    <template v-else>
                      {{ spec.detailNameEn }}
                    </template>
                  </v-col>
                  <v-col>
                    <div
                      v-if="$store.state.usedCountry && detail.containSpec === '1'"
                      class="me-auto font-medium d-flex align-center justify-center"
                    >
                      <span class="me-2">{{ $store.getters.countryGetter.currency }}{{ (priceRate(spec) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                    </div>
                  </v-col>
                  <v-col>
                    <Stepper
                      :value="+spec.buNumber"
                      square
                      @update:value="spec.buNumber = $event"
                      @update:minus="spec.buNumber = $event"
                      @update:plus="spec.buNumber = $event"
                    />
                  </v-col>
                </v-row>
                <v-divider />
              </div>
            </template>
            <div
              v-if="detail.containSpec === '0'"
              class="black--text font-medium my-2"
            >
              <template v-if="$store.getters.languageGetter === '1'">
                كمية:
              </template>
              <template v-else>
                Quantity:
              </template>
            </div>
            <div
              v-if="detail.containSpec === '0'"
              class="d-flex align-center mb-4"
            >
              <Stepper
                class="me-4"
                :value="+quantity"
                :disabled="quantity <= +detail.moq"
                @update:value="quantity = $event"
                @update:minus="quantity = $event"
                @update:plus="quantity = $event"
              />
              <div class="grey--text">
                {{ detail.stock }} {{ $store.getters.languageGetter === '1' ? detail.unitName : detail.unitNameEn }} <template v-if="$store.getters.languageGetter === '1'">
                  متوفرة
                </template>
                <template v-else>
                  available
                </template>
              </div>
            </div>
            <v-card
              class="mb-2 mt-4 px-4"
              color="#f9f9f9"
              outlined
              flat
            >
              <v-row>
                <v-col
                  v-for="(item, i) in detail.units || []"
                  :key="i"
                  cols="auto"
                  class="position-relative"
                  :class="detail.units && detail.units.length && i < detail.units.length - 1 ? 'after-line' : ''"
                >
                  1 {{ $store.getters.languageGetter === '1' ? item.unitName : item.unitNameEn }} = {{ item.packeNum }} {{ $store.getters.languageGetter === '1' ? detail.unitName : detail.unitNameEn }}
                </v-col>
              </v-row>
            </v-card>
            <div class="mb-2 mt-4">
              <v-btn
                depressed
                text
                class="px-0"
                @click="setGoodsFavorite"
              >
                <v-icon
                  left
                  :size="setting ? 20 : 16"
                  :color="detail.isCollect === '1' ? '#ff4747' : '#f7b4a1'"
                >
                  mdi-star {{ setting ? 'mdi-spin' : '' }}
                </v-icon>
                <span class="font-medium">
                  <template v-if="$store.getters.languageGetter === '1'">أضف إلى المفضلة</template>
                  <template v-else>
                    Add to collection
                  </template></span>
              </v-btn>
            </div>
            <div class="mb-4">
              <v-btn
                large
                color="#ff4747"
                depressed
                dark
                class="me-4 px-12"
                :loading="buying"
                @click="buyNow"
              >
                <span class="text-h5"><template v-if="$store.getters.languageGetter === '1'">اشتري الآن</template>
                  <template v-else>
                    Buy Now
                  </template></span>
              </v-btn>
              <v-btn
                large
                color="#ff9a00"
                depressed
                dark
                class="px-8"
                :loading="adding"
                @click="addToCart"
              >
                <v-icon
                  left
                  size="18px"
                  color="#fff"
                >
                  mdi-cart-outline
                </v-icon>
                <span class="text-h5"><template v-if="$store.getters.languageGetter === '1'">أضف إلى السلة</template>
                  <template v-else>
                    Add to Cart
                  </template></span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div :class="$store.state.mobile ? '' : 'px-2'">
      <v-divider v-if="$store.state.mobile" />
      <div
        v-if="$store.state.mobile"
        class="sepration"
      />
      <div
        class="px-4 py-2 text-h5 text-uppercase font-medium"
        :class="$store.state.mobile ? '' : 'mt-6 grey lighten-3'"
      >
        <template v-if="$store.getters.languageGetter === '1'">
          تفاصيل المنتج
        </template>
        <template v-else>
          overview
        </template>
      </div>
      <v-divider v-if="$store.state.mobile" />
      <v-container class="img-fluid mb-12">
        <div v-html="$store.getters.languageGetter === '1' ? detail.detailDesc : detail.detailDescEn" />
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Stepper from '@/components/StepperSquare.vue';

export default {
  name: 'GoodsDetail',
  components: {
    Stepper,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      swipeCarousel: 0,
      detail: {},
      breadcrumbs: [],
      loading: false,
      activeIndex: 0,
      specImg: '',
      quantity: 1,
      specIds: [],
      specItemNames: [],
      buying: false,
      adding: false,
      setting: false,
      height: 414,
    };
  },
  computed: {
    activeImg() {
      return this.detail.images && this.detail.images.length
        ? this.detail.images[this.activeIndex].picPath
        : '';
    },
    detailSpecs() {
      return this.detail.detail.map((item) => item.detailName.split('/'));
    },
    detailNames() {
      return this.detailSpecs.map((arr) => this.addParenthesisToArr(arr));
    },
    specOriginal() {
      return this.detail.spec;
    },
    detailNameSelected() {
      return this.specItemNames.join('/');
    },
    specItemNamesParenthsised() {
      return this.addParenthesisTo(this.specItemNames);
    },
    goodsDetail() {
      return this.goodsDetailIndex === -1
        ? this.detail.detail[0]
        : this.detail.detail[this.goodsDetailIndex];
    },
    goodsDetailIndex() {
      return this.detailSpecs.findIndex((arr) => this.specItemNames.every((str) => arr.includes(str)));
    },
    countryPrice() {
      return this.detail.containSpec === '1'
        ? this.detail.detail[
          this.goodsDetailIndex === -1 ? 0 : this.goodsDetailIndex
        ].countryPrice
        : this.detail.countryPrice;
    },
    goodsDetailSelected() {
      return this.detail.containSpec === '0' ? [
        {
          goodDetailId: this.goodsDetail.id,
          buUnitId: this.detail.unitId,
          packeNum: 1,
          buNumber: this.quantity,
        },
      ] : this.detail.detail.filter((item) => +item.buNumber, this.detail.detail).map((item) => ({
        goodDetailId: item.id,
        buUnitId: this.detail.unitId,
        packeNum: 1,
        buNumber: item.buNumber,
      }));
    },
    params() {
      return this.goodsDetail
        ? {
          goodId: this.detail.id,
          detail: this.goodsDetailSelected,
          priceStatus: '0',
        }
        : {
          goodId: this.detail.id,
          detail: this.detail.detail,
        };
    },
  },
  watch: {
    $route() {
      this.loadPageData();
    },
  },
  created() {
    this.height = document.documentElement.clientWidth;
    this.loadPageData();
  },
  methods: {
    ...mapActions('goods', [
      'getGoodsDetailAsync',
      'addToCartAsync',
      'setGoodsFavoriteAsync',
      'setGoodsUnfavoriteAsync',
    ]),
    downLoadImg(img) {
      if (img) {
        window.open(img);
      }
    },
    loadPageData() {
      this.loading = true;
      this.getGoodsDetailAsync({ id: this.id })
        .then((res) => {
          this.detail = res;
          this.quantity = res.moq;
          let breadcrumbs = [
            {
              text:
                this.$store.getters.languageGetter === '1'
                  ? 'الصفحة الرئيسية'
                  : 'Home',
              disabled: false,
              to: '/',
            },
            {
              text:
                this.$store.getters.languageGetter === '1'
                  ? 'قائمة المنتجات'
                  : 'Products',
              disabled: false,
              to: '/goods/list',
            },
          ];
          if (res.containSpec === '1') {
            this.specIds = Array(res.spec.length).fill('');
            this.specItemNames = Array(res.spec.length).fill('');
            const specs = res.spec;
            specs.map((item) => {
              item.specItem.map((subitem) => {
                if (
                  this.detailNames.find((specName) => specName.includes(`(${subitem.itemName})`))
                ) {
                  subitem.disabled = false;
                } else {
                  subitem.disabled = true;
                }
                return subitem;
              });
              return item;
            });
            this.$set(this.detail, 'spec', specs);
          }
          breadcrumbs = breadcrumbs.concat([
            {
              text:
                this.$store.getters.languageGetter === '1'
                  ? res.categoryName
                  : res.categoryNameEn,
              disabled: false,
              to: {
                name: 'GoodsList',
                query: {
                  categoryId: res.categoryId,
                  categoryName: res.categoryName,
                  categoryNameEn: res.categoryNameEn,
                  p: 1,
                },
              },
            },
            {
              text:
                this.$store.getters.languageGetter === '1'
                  ? res.dnames
                  : res.dnamesEn,
              disabled: true,
            },
          ]);
          this.breadcrumbs = breadcrumbs;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setSpecDisabled(specItem = {}, i) {
      if (this.specIds[i] === specItem.id) {
        this.$set(this.specIds, i, '');
        this.$set(this.specItemNames, i, '');
      } else {
        this.$set(this.specIds, i, specItem.id);
        this.$set(this.specItemNames, i, specItem.itemName);
      }
      this.findSpecDisabled(i);
    },
    findSpecDisabled(i) {
      const specs = JSON.parse(JSON.stringify(this.specOriginal));
      // 除当前序号外的数组项循环判断是否置灰
      // 判断依据:
      // 1. 当前序号i，取得当前已选规格名用循环项的规格替换当前序号i对应位置的规格名
      // 2. 若去掉当前选中规格的对应序号内容用循环项内容替换再去可选detail寻找是否可选以置灰
      specs.map((item, index) => {
        item.specItem.map((subitem) => {
          const specItemNamesLocal = JSON.parse(
            JSON.stringify(this.specItemNames),
          );
          if (i === index) {
            specItemNamesLocal[i] = subitem.itemName;
          } else {
            specItemNamesLocal[index] = subitem.itemName;
          }
          const specItemsStrLocal = this.addParenthesisToArr(
            specItemNamesLocal,
          );
          const isExist = this.detailNames.find((arr) => specItemsStrLocal.every((str) => arr.includes(str)));
          if (isExist) {
            subitem.disabled = false;
          } else {
            subitem.disabled = true;
          }
          return subitem;
        });
        return item;
      });
      this.$set(this.detail, 'spec', specs);
    },
    addParenthesisTo(arr) {
      let v = '';
      arr.map((item) => {
        if (!item) {
          return item;
        }
        v += `(${item})`;
        return item;
      });
      return v;
    },
    checkBuyable() {
      if (!this.$store.state.user) {
        this.$emit('update:login');
        return false;
      }
      if (!this.$store.state.usedCountry) {
        this.$store.commit('TOGGLE_SNACKBAR', {
          type: 'error',
          text:
            this.$store.getters.languageGetter === '1'
              ? 'الرجاء تحديد بلد أولا'
              : 'Please select a country first',
        });
        if (this.$store.state.mobile) {
          document.documentElement.scrollTop = 0;
          this.$emit('update:show-popup');
        }
        return false;
      }
      // if (this.detail.containSpec === '1' && !this.goodsDetail) {
      //   this.$store.commit('TOGGLE_SNACKBAR', {
      //     type: 'error',
      //     text: "Please select product's specification",
      //   });
      //   return false;
      // }
      const count = this.goodsDetailSelected.reduce((acc, item) => {
        acc += +item.buNumber;
        return acc;
      }, 0);
      if (!this.goodsDetailSelected.length || count < +this.detail.moq) {
        this.$store.commit('TOGGLE_SNACKBAR', {
          type: 'error',
          text: this.$store.getters.languageGetter === '1' ? 'يرجى مطابقة الحد الأدنى لكمية الطلب' : 'Please match the minimum order quantity',
        });
        return false;
      }
      return true;
    },
    buyNow() {
      if (this.checkBuyable()) {
        this.buying = true;
        this.addToCartAsync(this.params)
          .then(() => {
            this.$router.push({
              name: 'CartList',
              query: { selected: this.goodsDetailSelected.map((item) => item.goodDetailId) },
            });
          })
          .finally(() => {
            this.buying = false;
          });
      }
    },
    addToCart() {
      if (this.checkBuyable()) {
        this.adding = true;
        this.addToCartAsync(this.params)
          .then(() => {
            this.$store.commit('TOGGLE_SNACKBAR', {
              type: 'success',
              text: 'Success',
            });
            this.quantity = this.detail.moq;
          })
          .finally(() => {
            this.adding = false;
          });
      }
    },
    setGoodsFavorite() {
      this.setting = true;
      if (this.detail.isCollect === '1') {
        this.setGoodsUnfavoriteAsync({ goodId: this.detail.id })
          .then(() => {
            this.$set(this.detail, 'isCollect', '0');
          })
          .finally(() => {
            this.setting = false;
          });
      } else {
        this.setGoodsFavoriteAsync({ goodId: this.detail.id })
          .then(() => {
            this.$set(this.detail, 'isCollect', '1');
          })
          .finally(() => {
            this.setting = false;
          });
      }
    },
    addParenthesisToArr(arr) {
      return arr.filter((item) => !!item).map((item) => `(${item})`);
    },
    priceRate(item) {
      if (this.detail.containSpec !== '1' && !item.countryPrice) {
        item.countryPrice = this.detail.countryPrice;
      }
      return (
        +item.countryPrice[this.$store.getters.countryGetter.id]
        * +this.$store.getters.countryGetter.rate
      );
    },
  },
};
</script>

<style>
.after-line::after {
  content: '|';
  color: #666;
  position: absolute;
  right: 0;
}
</style>
